<template>
  <div class="animated fadeIn customer-account-upload">
    <div class="page-header">
      <div>
        <h1>Upload Customer Accounts</h1>
        <p>Excel import for customer account master data.</p>
      </div>
      <button type="button" class="btn btn-outline-primary" @click="refreshTable()">Refresh</button>
    </div>

    <section class="upload-panel">
      <div class="upload-content">
        <div class="upload-title">Excel file</div>
        <div class="upload-requirements">
          Required columns: <strong>Customer Account</strong>, <strong>Customer Name</strong>
        </div>
        <div class="upload-controls">
          <label class="file-picker">
            <input type="file" @change="fileChange($event.target.files)" accept=".xls,.XLS,.xlsx,.XLSX">
            <span>{{ selectedFileName }}</span>
          </label>
          <button type="button" class="btn btn-primary" @click="uploadFile()" :disabled="!fileToUpload">Upload</button>
        </div>
      </div>
    </section>

    <MyModal v-if="showUploadingModal" v-on:close="closeUploadingModal()" headerTitle="Uploading..." bodyMessage="Please wait"/>
    <MyModal v-if="showUploadingSuccessModal" v-on:close="closeUploadSuccessModal()" headerTitle="Success" bodyMessage="Upload Success."/>
    <MyModal v-if="showUploadingFailedModal" v-on:close="closeUploadFailModal()" headerTitle="Failed" :bodyMessage="uploadFailedMessage"/>

    <section class="table-panel">
      <div class="table-toolbar">
        <div class="toolbar-group">
          <span>Rows Per Page</span>
          <b-dropdown id="ddown3" :text="rowsPerPageCText" size="sm">
            <b-dropdown-item href="#" @click="rowsPerPageSelected(10)">10</b-dropdown-item>
            <b-dropdown-item href="#" @click="rowsPerPageSelected(20)">20</b-dropdown-item>
            <b-dropdown-item href="#" @click="rowsPerPageSelected(50)">50</b-dropdown-item>
            <b-dropdown-item href="#" @click="rowsPerPageSelected(100)">100</b-dropdown-item>
            <b-dropdown-item href="#" @click="rowsPerPageSelected(200)">200</b-dropdown-item>
            <b-dropdown-item href="#" @click="rowsPerPageSelected(500)">500</b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="toolbar-pagination">
          <b-pagination
            size="sm"
            :total-rows="totalRowsC"
            v-model="currentPage"
            :per-page="rowsPerPageC"
            hide-ellipsis
            :limit="paginationButtonsLimit"
            align="center"
            @change="pageChanged">
          </b-pagination>
        </div>
        <div class="toolbar-total">
          Total Rows {{totalRowsC}}
        </div>
      </div>

      <div class="table-wrap">
        <b-table small bordered hover :items="tableRows" :fields="tableHeaders" @row-clicked="tableRowClicked" id="uploadedCustomerAccountsTable">
          <template slot="cell(status)" slot-scope="row">
            <span class="status-text">{{row.item.status}}</span>
            <button type="button" v-if="row.item.status == 'NEW'" class="btn btn-sm btn-primary" @click="importFile(row.item.docId, row.item.fileName, row.item.status)">Import</button>
          </template>
        </b-table>
      </div>

      <img src="static/img/Rolling.svg" alt="Loading data..."
        style="margin-left:auto; margin-right:auto; display: block;"
        v-if="showLoadingAnimation">
      <p class="empty-state" v-if="showLoadingError">Loading error</p>
      <p class="empty-state" v-if="showNoResult">No Result</p>
    </section>

    <MyModal v-if="showImportingModal" v-on:close="closeImportingModal()" headerTitle="Importing..." bodyMessage="Do not navigate away from this screen, please wait..."/>
    <MyModal v-if="showImportingSuccessModal" v-on:close="closeImportSuccessModal()" headerTitle="Success" bodyMessage="Import Completed."/>
    <MyModal v-if="showImportingFailedModal" v-on:close="closeImportFailModal()" headerTitle="Failed" :bodyMessage="importFailedMessage"/>
  </div>
</template>

<script>
import { MyModal } from '../components/'
export default {
  name: 'customeraccountupload',
  components: {
    MyModal
  },
  data () {
    return {
      fileToUpload: null,
      currentPage: 1,
      paginationButtonsLimit: 3
    }
  },
  created: function () {
    this.$store.dispatch('cauploadmod/showAllUploads', { orderBys: 'uploadedDate' })
  },
  methods: {
    fileChange: function (files) {
      for (let eachFile of files) {
        console.log('file name: ' + eachFile.name)
        console.log('file size: ' + eachFile.size + 'bytes')
        console.log('file type: ' + eachFile.type)
        this.fileToUpload = eachFile
      }
    },
    uploadFile: function () {
      this.$store.dispatch('cauploadmod/uploadFileToFirebaseStorage', {file: this.fileToUpload})
    },
    closeUploadingModal: function () {
      this.$store.commit('cauploadmod/toggleUploadingModal', false)
    },
    closeUploadSuccessModal: function () {
      this.$store.commit('cauploadmod/toggleUploadingSuccessModal', false)
      this.fileToUpload = null
    },
    closeUploadFailModal: function () {
      this.$store.commit('cauploadmod/toggleUploadingFailedModal', false)
    },
    closeImportingModal: function () {
    },
    closeImportSuccessModal: function () {
      this.$store.commit('cauploadmod/toggleImportingSuccessModal', false)
    },
    closeImportFailModal: function () {
      this.$store.commit('cauploadmod/toggleImportingFailedModal', false)
    },
    rowsPerPageSelected: function (rows) {
      let intRows = parseInt(rows)
      if (this.$store.state.cauploadmod.rowsPerPage !== intRows) {
        this.currentPage = 1
        this.$store.commit('cauploadmod/changePageNumber', this.currentPage)
        this.$store.commit('cauploadmod/setRowsPerPage', intRows)
        this.$store.dispatch('cauploadmod/showAllUploads', { orderBys: 'uploadedDate' })
      }
    },
    importFile: function (docId, filename, status) {
      this.$store.dispatch('cauploadmod/importFile', { docId: docId, filename: filename, status: status })
    },
    pageChanged: function (pageNumber) {
      this.currentPage = pageNumber
      this.$store.commit('cauploadmod/changePageNumber', this.currentPage)
      this.$store.dispatch('cauploadmod/showAllUploads', { orderBys: 'uploadedDate' })
    },
    refreshTable: function () {
      this.currentPage = 1
      this.$store.dispatch('cauploadmod/showAllUploads', { orderBys: 'uploadedDate' })
    },
    tableRowClicked: function (item, index, event) {
      this.$store.commit('cauploadmod/selectTableRow', item.docId)
      this.selectedRowItem = item
    }
  },
  computed: {
    showUploadingModal: function () {
      return this.$store.state.cauploadmod.showUploadingModal
    },
    showUploadingSuccessModal: function () {
      return this.$store.state.cauploadmod.showUploadingSuccessModal
    },
    showUploadingFailedModal: function () {
      return this.$store.state.cauploadmod.showUploadingFailedModal
    },
    uploadFailedMessage: function () {
      return this.$store.state.cauploadmod.uploadFailedMessage || 'Upload Failed.'
    },
    showImportingModal: function () {
      return this.$store.state.cauploadmod.showImportingModal
    },
    showImportingSuccessModal: function () {
      return this.$store.state.cauploadmod.showImportingSuccessModal
    },
    showImportingFailedModal: function () {
      return this.$store.state.cauploadmod.showImportingFailedModal
    },
    importFailedMessage: function () {
      return this.$store.state.cauploadmod.importFailedMessage
    },
    tableRows: function () {
      return this.$store.state.cauploadmod.all
    },
    tableHeaders: function () {
      return this.$store.getters['cauploadmod/getHeaders']
    },
    rowsPerPageCText: function () {
      return '' + this.$store.state.cauploadmod.rowsPerPage
    },
    totalRowsC: function () {
      return this.$store.state.cauploadmod.totalRows
    },
    rowsPerPageC: {
      get: function () {
        return this.$store.state.cauploadmod.rowsPerPage
      },
      set: function (newValue) {
        this.$store.commit('cauploadmod/setRowsPerPage', newValue)
      }
    },
    showLoadingAnimation: function () {
      return this.$store.state.cauploadmod.showLoadingAnimation
    },
    showLoadingError: function () {
      return this.$store.state.cauploadmod.showLoadingError
    },
    showNoResult: function () {
      return this.$store.state.cauploadmod.showNoResult
    },
    selectedFileName: function () {
      if (this.fileToUpload) {
        return this.fileToUpload.name
      }
      return 'Choose .xls or .xlsx file'
    }
  }
}
</script>

<style scoped>
.customer-account-upload {
  padding: 18px 20px 28px;
}

.page-header {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  margin-bottom: 18px;
}

.page-header h1 {
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 4px;
}

.page-header p {
  color: #6c757d;
  margin: 0;
}

.upload-panel,
.table-panel {
  background: #fff;
  border: 1px solid #d8dbe0;
  border-radius: 4px;
  margin-bottom: 18px;
}

.upload-content {
  padding: 18px;
}

.upload-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
}

.upload-requirements {
  color: #6c757d;
  margin-bottom: 14px;
}

.upload-controls {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.file-picker {
  align-items: center;
  border: 1px solid #c8ced3;
  border-radius: 4px;
  cursor: pointer;
  display: inline-flex;
  margin: 0;
  min-height: 36px;
  min-width: 280px;
  padding: 7px 10px;
}

.file-picker input {
  display: none;
}

.file-picker span {
  color: #495057;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.table-toolbar {
  align-items: center;
  border-bottom: 1px solid #d8dbe0;
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr auto 1fr;
  padding: 12px 14px;
}

.toolbar-group {
  align-items: center;
  display: flex;
  gap: 8px;
}

.toolbar-pagination {
  display: flex;
  justify-content: center;
}

.toolbar-pagination >>> .pagination {
  margin-bottom: 0;
}

.toolbar-total {
  color: #495057;
  text-align: right;
}

.table-wrap {
  overflow-x: auto;
  padding: 14px;
}

.status-text {
  display: inline-block;
  margin-right: 8px;
  min-width: 72px;
}

.empty-state {
  color: #6c757d;
  margin: 14px 0;
  text-align: center;
}

@media (max-width: 767px) {
  .page-header {
    gap: 12px;
  }

  .table-toolbar {
    grid-template-columns: 1fr;
  }

  .toolbar-pagination,
  .toolbar-total {
    justify-content: flex-start;
    text-align: left;
  }

  .file-picker {
    min-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/CustomerAccountUpload.vue